var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 0H14v12H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.787 2.66c0-.291-.266-.527-.593-.527h-1.84L9.514.887C9.299.57 8.913.375 8.496.375H6.004c-.417 0-.803.194-1.018.512l-.84 1.246h-1.84c-.328 0-.593.236-.593.527v.264c0 .145.133.264.297.264h.494v7.382c0 .583.531 1.055 1.186 1.055h7.12c.655 0 1.186-.472 1.186-1.055V3.187h.495c.163 0 .296-.118.296-.263V2.66zm-9.097.527h7.12v7.252c0 .072-.067.131-.149.131H3.84c-.082 0-.149-.059-.149-.132v-7.25zm1.84-1.054h3.44l-.43-.64a.153.153 0 0 0-.128-.063H6.088c-.052 0-.1.024-.127.064l-.432.639zm.929 2.373v4.746c0 .146-.133.264-.297.264H5.57c-.164 0-.297-.118-.297-.264V4.506c0-.146.133-.264.297-.264h.593c.164 0 .297.118.297.264zm2.472-.264h-.593c-.164 0-.297.118-.297.264v4.746c0 .146.133.264.297.264h.593c.164 0 .297-.118.297-.264V4.506c0-.146-.133-.264-.297-.264z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e960d052865157eb2b8178510fbc0abd.svg";
export { ForwardRef as ReactComponent };